import { jsx as l } from "react/jsx-runtime";
import u from "react";
const f = (t) => {
  for (; t.startsWith("/") || t.endsWith("/"); )
    t.startsWith("/") && (t = t.slice(1)), t.endsWith("/") && (t = t.slice(0, -1));
  return t;
}, a = (t, { contentUrl: s, version: r, folderpath: e }) => {
  if (!t) return;
  if (t.startsWith("http")) return t;
  if (!s) return;
  const [i, n, o] = [
    f(t),
    f(s),
    f(e || "")
  ];
  return `${n}/${e ? `${o}/` : ""}${i}${r ? `?version=${r}` : ""}`;
}, c = (t, { contentUrl: s, version: r }) => t.startsWith("http") ? t : `${s}/tts${t.startsWith("/") ? "" : "/"}${t}?version=${r}`, g = ({ src: t, isTts: s }, r) => s === !1 ? a(t, r) : c(t, r), $ = u.forwardRef(
  ({ src: t, assetsDetails: s, ...r }, e) => {
    const i = a(t, s);
    if (!i) return null;
    const { alt: n, ...o } = r;
    return /* @__PURE__ */ l("img", { ref: e, ...o, src: i, alt: n ?? "" });
  }
);
$.displayName = "Image";
export {
  $ as I,
  g as a,
  c as b,
  a as g
};
//# sourceMappingURL=Image-3okXnSA9.js.map
